/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createAdDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	campaignId: z.string().uuid(),
	organisationId: z.string().uuid(),
	target: z.string(),
	cta: z.string(),
	location: z.string(),
	metaCallToAction: z.string(),
	metaDescription: z.string(),
	metaHeadline: z.string(),
	metaPrimaryText: z.string(),
	subtitle: z.string(),
	title: z.string(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
})

export type CreateAdDataSchema = z.infer<typeof createAdDataSchema>
